import React from "react";
import { Grid } from "@mui/material";

import DatePickerComponent from "./DatePicker";

export default function DateTestDialog({ formikProps }) {
  return (
    <Grid size={12}>
      <DatePickerComponent
        fieldDetails={formikProps.values}
        formikProps={formikProps}
        disabled={!formikProps.values.editable}
      />
    </Grid>
  );
}
